import {Switch} from "react-router-dom";
import RouteWithSubRoutes from "../common/components/shared/routeWithSubRoutes/routeWithSubRoutes";

export default function RouteSwitch(props: any) {
    return (
        <Switch>
            {props.routes.map((route: any, i:number) => (
                <RouteWithSubRoutes key={i} {...route} />
            ))}
        </Switch>
    );
}
